module.exports = __webpack_public_path__ + "img/chat.7d9c84d2.svg";